import { fromJS } from 'immutable';
import * as types from 'src/redux/constants';

const initialState = fromJS({
  loginFromKaruna: false,
  isLoggedInFromLocationBasedPinSignin: false,
  isDisabledBottomNavigation: false,
});

export default function appSettings(state = initialState, action) {
  switch (action.type) {
    case types.LOGIN_FROM_LOCATION_BASED_DEVICE:
      return state.set('isLoggedInFromLocationBasedPinSignin', action.payload.value);

    case types.IS_DISABLED_BOTTOM_NAVIGATION:
      return state.set('isDisabledBottomNavigation', action.payload.value);

    default:
      return state;
  }
}
